export var ColorPickerStyles = function ColorPickerStyles(props) {
  return {
    input: {
      selectors: {
        '&.ms-TextField': {
          paddingRight: 4
        },
        '.ms-TextField-field': {
          minWidth: 'auto',
          padding: 5,
          textOverflow: 'clip'
        }
      }
    },
    table: {
      selectors: {
        'tbody td:last-of-type .ms-ColorPicker-input': {
          paddingRight: 0
        }
      }
    },
    tableHeader: {
      selectors: {
        td: {
          paddingBottom: 4
        }
      }
    }
  };
};
export var ColorRectangleStyles = function ColorRectangleStyles(props) {
  var theme = props.theme;
  var palette = theme.palette,
      effects = theme.effects;
  return {
    root: {
      border: "1px solid " + palette.neutralLighter,
      borderRadius: effects.roundedCorner2,
      marginBottom: 8
    },
    thumb: {
      borderColor: palette.neutralTertiary,
      boxShadow: effects.elevation8
    }
  };
};
export var ColorSliderStyles = function ColorSliderStyles(props) {
  var theme = props.theme;
  var palette = theme.palette,
      effects = theme.effects;
  return {
    root: {
      borderRadius: effects.roundedCorner2,
      marginBottom: 8
    },
    sliderThumb: {
      borderColor: palette.neutralTertiary,
      boxShadow: effects.elevation8
    }
  };
};